import { gql } from 'urql';

export const NucleusDatasetInfo = gql`
  query NucleusDatasetInfo($datasetId: ID!) {
    viewer {
      __typename
      id
    }

    nucleusDatasetById(id: $datasetId) {
      ...datasetInfo
      model_runs {
        ...modelRunInfo
      }
      track_count
    }
  }

  query NucleusDatasetSchema($datasetId: ID!) {
    nucleusDatasetById(id: $datasetId) {
      __typename
      id
      schema
    }
  }

  query NucleusDatasetMinimalInfo($datasetId: ID!) {
    nucleusDatasetById(id: $datasetId) {
      ...datasetInfo
    }
  }

  fragment datasetInfo on NucleusDataset {
    __typename
    id
    name
    created_at
    delete_status
    is_public
    is_indexed_image
    is_indexed_object
    is_scene
    is_label_linked
    rapid_project_id
    invalid_task_types
    sliceCount
    itemCount
    license_id
    viewer_is_owner
    viewer_can_edit
    type
    colorScheme {
      scheme
    }
    searchIndexes {
      ...searchIndexConfig
    }
    config {
      ...datasetConfig
    }
    pending_jobs {
      ...jobInfo
    }
    has_clip_index
    scene_distinct_sensor_names
    hasGeoData
    tags
  }

  fragment searchIndexConfig on NucleusSearchIndex {
    __typename
    id
    status
    index_level
    index_type
    is_primary
    embedding_type
    embedding_dim
  }

  fragment datasetConfig on NucleusDatasetConfigType {
    productConfig {
      ...configItem
    }
    variantConfig {
      ...configItem
    }
    variantMergeConfig {
      ...configItem
    }
  }

  fragment configItem on ConfigItemType {
    path
    displayType
    label
  }

  fragment modelRunInfo on NucleusModelRun {
    __typename
    id
    name
    started_at
    status
    model_id
  }

  fragment jobInfo on NucleusJob {
    __typename
    id
    user {
      __typename
      id
      firstName
      lastName
    }
    job_type
    created_at
    ended_at
    status
    user_id
    completed_steps
    total_steps
    last_updated
    archived
    metadata_public
    progress_counters
    dataset {
      __typename
      id
      name
    }
  }
`;

export * from './useNucleusDatasetInfo.generated';
